
export default superclass => class extends superclass  {
    getKeyMapping(slice) {
        let keyEngine = this.sequencerEngine.keyboardEngine;
        if (!keyEngine) {
            return undefined;
        }
        let mappings = keyEngine.keyMappings;

        for (let key in mappings) {
            let {trackNumber, sliceNumber} = mappings[key];
            if (trackNumber === this.trackNumber &&
                (slice === undefined || slice == sliceNumber)) {
                return key;
            }
        }
        return undefined;
    }

    mapToKey(key, sliceNumber=0) {
        this.sequencerEngine.keyboardEngine.map(key, this.trackNumber, sliceNumber);
    }

    getPadMapping() {
    }
}
